<template>
    <transition name="fade">
      <div v-if="visible" :class="['snackbar', type]">
        {{ message }}
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch } from "vue";
  
  const props = defineProps({
    message: String,
    type: { type: String, default: "success" },
    show: Boolean
  });
  
  const visible = ref(false);
  
  watch(() => props.show, (val) => {
    if (val) {
      visible.value = true;
      setTimeout(() => {
        visible.value = false;
      }, 3000);
    }
  });
  </script>
  
  <style scoped>
  .snackbar {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 14px 24px;
    border-radius: 12px;
    color: white;
    font-family: "Eastman-Medium", sans-serif;
    z-index: 9999;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }
  
  .snackbar.success {
    background-color: #2173e5;
  }
  
  .snackbar.error {
    background-color: #E65122;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  </style>